import {Grid} from "@mui/material";
import {useState} from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "../ui/TabPanel";
import { useEffect } from "react"
import AccountCard from "../cards/AccountCard";
import AddAccount from "../modals/AddAccount"
import DeleteAccount from "../modals/DeleteAccount"
import AccountTransactions from "./AccountTransactions";
import LoadingContent from "../common/LoadingContent"
import { useParams } from "react-router-dom"
import { getAccount } from "../../api"
import { useSnackbar } from "notistack"

const Account = () => {
  const [account, setAccount] = useState({});
  const [tabIndex, setTabIndex] = useState(0);
  const changeTab = (_, newValue) => setTabIndex(newValue);
  const [editModal, setEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar()

  const openEditModal = () => setEditModal(true)
  const closeEditModal = () => setEditModal(false)
  const openDeleteModal = () => setDeleteModal(true)
  const closeDeleteModal = () => setDeleteModal(false)

  const fetchAccount = () => {
    setLoading(true)
    getAccount(id)
      .then((res) => {
        setAccount(res.data)
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchAccount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LoadingContent loading={loading}>
        <AccountCard
          data={account}
          edit={openEditModal}
          remove={openDeleteModal}
          noView
        />
        </LoadingContent>
      </Grid>
      <Grid item xs={8}>
        <Box sx={{borderBottom: 1, borderColor: "divider"}}>
          <Tabs value={tabIndex} onChange={changeTab}>
            <Tab label="Transactions" />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <AccountTransactions setAccount={setAccount} />
        </TabPanel>
      </Grid>
      <AddAccount isOpen={editModal} close={closeEditModal} data={account} />
      <DeleteAccount isOpen={deleteModal} close={closeDeleteModal} data={account} />
    </Grid>
  );
};

export default Account;
